export default "__VITE_ASSET__CE5Xe$F7__"